import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { SlidersHorizontal } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Menu } from '@liveauctioneers/hammer-ui-core/menu';
import { H5 } from '@liveauctioneers/hammer-ui-core/text';

import Conversions from './components/Conversions/Conversions';

type Props = {
    catalogId: number;
    onCurrencyChanged: (value) => void;
    selectedCurrency: string;
};

const LiveAuctionSettingsMenu = ({ catalogId = 0, onCurrencyChanged, selectedCurrency }: Props) => {
    return (
        <Menu
            hasRoundedBorders
            isCustomContent
            menuPlacement="bottom-end"
            menuSize="md"
            numberOfColumns={1}
            trigger={
                <IconButton
                    aria-label="Settings"
                    icon={SlidersHorizontal}
                    size="sm"
                />
            }
        >
            <div
                className="min-w-[220px] overflow-visible px-sm py-xs"
                data-testid="settingsMenu"
            >
                <H5 className="mb-xs">
                    <FormattedMessage id="bidding_console.console.settingsMenu.headerText" />
                </H5>
                <Conversions
                    catalogId={catalogId}
                    onCurrencyChanged={onCurrencyChanged}
                    selectedCurrency={selectedCurrency}
                />
            </div>
        </Menu>
    );
};

export default LiveAuctionSettingsMenu;
